import React from 'react';

interface DateSeparatorProps {
  date: string; // ISO date string
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  const formatDate = (dateString: string) => {
    const messageDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Reset time parts for accurate comparison
    const messageDateOnly = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

    if (messageDateOnly.getTime() === todayOnly.getTime()) {
      return 'Vandaag';
    } else if (messageDateOnly.getTime() === yesterdayOnly.getTime()) {
      return 'Gisteren';
    } else {
      return messageDate.toLocaleDateString('nl-NL', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    }
  };

  return (
    <div className="flex items-center justify-center my-6">
      <div className="font-mono text-xs font-medium text-fg-faint bg-white/[.05] px-3 py-1 rounded-full">
        {formatDate(date)}
      </div>
    </div>
  );
};

export default DateSeparator;